import { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { Toast } from "primereact/toast";
import Bredcrum from "../../components/bredcrum";
import { Submissionbtn } from "../../components/buttons";
import { productservices } from "../../services/productServices";
import { useNavigate } from "react-router-dom";
import {HandleClose} from '../../helpers/formclose';

const AddCategory = () => {
  const initialValues = {
    category_name: "",
    product_nature: "",
    status: "active",
  };
  const toast = useRef(null);
  const [submitted,setSubmitted] = useState(true);
   const navigate = useNavigate();

//   const validationSchema = Yup.object({
//     category_name: Yup.string()
//       .required("Category name is required"),
//     product_nature: Yup.string()
//       .required("Product nature is required"),
//     status: Yup.string()
//       .required("Status is required"),
//   });

  const handleSave = async (values) => {
    console.log("Form Data:", values);
     const response = await productservices.createcategory(values);
     if(response.status == 200){
         await toast.current.show({
            severity: "success",
            summary: "Categories",
            detail: `${response.data.data}`,
          });
          navigate(-1);
     }else{
        toast.current.show({
            severity: "error",
            summary: "Categories",
            detail: `${response.data.data}`,
          });
     }
    // API call here
  };

  const handleClose = () => {
    // Reset form or close modal logic
    console.log("Form Closed");
  };

  return (
    <>
  <Toast ref={toast} />
  <Bredcrum title={"Category / Add"} divider={false} />

  <div className="row">
    {/* <Titlebar text={"Add Category"} /> */}

    <div className="col-md-12 mt-3">
      <div className="card ps-3 pe-3">
        <div className="card-body card-body-style">
          <div className="row">
            <div className="container mt-4">

              <Formik
                initialValues={{
                  category_name: "",
                  product_nature: "",
                  status: "Active",
                }}
                onSubmit={(values) => {
                  console.log("Category Values", values);
                  handleSave(values);
                }}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="row">

                      {/* Category Name */}
                      <div className="col-md-6 form-group">
                        <Label name="Category Name" />
                        <Field
                          type="text"
                          name="category_name"
                          className="form-control"
                          placeholder="Enter Category Name"
                          required
                        />
                      </div>

                      {/* Product Nature */}
                      <div className="col-md-6 form-group">
                        <Label name="Product Nature" />
                        <Field
                          as="select"
                          name="product_nature"
                          className="form-control"
                          required
                          onChange={(e) =>
                            setFieldValue("product_nature", e.target.value)
                          }
                        >
                          <option value="">Select Product Nature</option>
                          <option value="perishable">Perishable</option>
                          <option value="non_perishable">Non-Perishable</option>
                          <option value="fragile">Fragile</option>
                          <option value="hazardous">Hazardous</option>
                        </Field>
                      </div>

                      {/* Status */}
                      <div className="col-md-6 form-group">
                        <Label name="Status" />
                        <Field
                          as="select"
                          name="status"
                          className="form-control"
                          required
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </Field>
                      </div>

                    </div>

                    <br />

                    {/* Action Buttons */}
                    <div className="row">
                      <div className="col-md-6">
                        <Submissionbtn issaved={submitted} />
                      </div>

                      {<HandleClose/>}
                    </div>

                  </Form>
                )}
              </Formik>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

  );
};

export default AddCategory;
